/* Kontextmenü: schwebendes Menü mit beliebig tiefen Untermenüs, Maus- und Tastaturbedienung.
 * Einträge: { t:'Text', run:fn, key:'Strg+C', dis:bool, chk:bool, danger:bool, sub:[Einträge] }, { sep:true }, { hdr:'Überschrift' }.
 * Nur textContent wird gesetzt (Texturnamen u. ä. stammen aus Dateien). */
const CtxMenu = (function () {
  'use strict';
  let root = null, panes = [], prevFocus = null, hoverT = null;

  function el(tag, cls, text) { const e = document.createElement(tag); if (cls) e.className = cls; if (text !== undefined) e.textContent = text; return e; }
  const isOpen = () => !!root;
  const usable = (r) => !r.it.dis;

  function close(noFocus) {
    if (!root) return;
    clearTimeout(hoverT);
    window.removeEventListener('keydown', onKey, true);
    window.removeEventListener('pointerdown', onDown, true);
    window.removeEventListener('blur', onAway);
    window.removeEventListener('resize', onAway);
    window.removeEventListener('wheel', onWheel, true);
    root.remove(); root = null; panes = [];
    if (!noFocus && prevFocus && prevFocus.focus) { try { prevFocus.focus({ preventScroll: true }); } catch (e) { /* ignorieren */ } }
    prevFocus = null;
  }
  function onAway() { close(true); }
  function onDown(e) { if (root && !root.contains(e.target)) close(true); }
  function onWheel(e) { if (root && !root.contains(e.target)) close(true); }

  function place(pane, x, y, anchor) {
    const el_ = pane.el, vw = window.innerWidth, vh = window.innerHeight;
    el_.style.maxHeight = (vh - 12) + 'px';
    el_.style.left = '0px'; el_.style.top = '0px';
    const r = el_.getBoundingClientRect(), w = r.width, h = r.height;
    let left = x, top = y;
    if (anchor) { // Untermenü neben der Zeile; passt rechts nichts hin, dann links
      left = anchor.right - 3; top = anchor.top - 4;
      if (left + w > vw - 4) left = Math.max(4, anchor.left - w + 3);
    } else if (left + w > vw - 4) left = Math.max(4, vw - w - 4);
    if (top + h > vh - 4) top = Math.max(4, vh - h - 4);
    el_.style.left = Math.round(left) + 'px'; el_.style.top = Math.round(top) + 'px';
  }

  function setActive(level, idx) {
    const p = panes[level]; if (!p) return;
    p.rows.forEach((r, i) => r.row.classList.toggle('act', i === idx));
    p.active = idx;
    if (idx >= 0 && p.rows[idx]) p.rows[idx].row.scrollIntoView({ block: 'nearest' });
  }
  function closeDeeper(level) { while (panes.length > level + 1) { const p = panes.pop(); p.el.remove(); } }

  function openSub(level, idx) {
    const p = panes[level], r = p && p.rows[idx];
    if (!r || !r.it.sub || r.it.dis) return null;
    closeDeeper(level);
    const np = makePane(r.it.sub, level + 1);
    root.append(np.el); panes.push(np);
    place(np, 0, 0, r.row.getBoundingClientRect());
    return np;
  }

  function activate(level, idx) {
    const p = panes[level], r = p && p.rows[idx];
    if (!r || r.it.dis) return;
    if (r.it.sub) { const np = openSub(level, idx); if (np) { const first = np.rows.findIndex(usable); setActive(level + 1, first); } return; }
    const run = r.it.run;
    close();
    if (run) run();
  }

  function makePane(items, level) {
    const pane = { el: el('div', 'ctxm-pane'), rows: [], active: -1 };
    pane.el.setAttribute('role', 'menu');
    const anyChk = items.some((i) => i.chk !== undefined);
    items.forEach((it) => {
      if (!it) return;
      if (it.sep) { pane.el.append(el('div', 'ctxm-sep')); return; }
      if (it.hdr) { pane.el.append(el('div', 'ctxm-hdr', it.hdr)); return; }
      const row = el('div', 'ctxm-item' + (it.dis ? ' dis' : '') + (it.sub ? ' sub' : '') + (it.danger ? ' danger' : ''));
      row.setAttribute('role', 'menuitem'); if (it.dis) row.setAttribute('aria-disabled', 'true'); if (it.tip) row.title = it.tip;
      if (anyChk) row.append(el('span', 'ctxm-mark', it.chk ? '✓' : ''));
      row.append(el('span', 'ctxm-label', it.t), el('span', 'ctxm-key', it.sub ? '▸' : (it.key || '')));
      const idx = pane.rows.length;
      row.addEventListener('pointerenter', () => {
        clearTimeout(hoverT);
        setActive(level, idx); closeDeeper(level);
        if (it.sub && !it.dis) hoverT = setTimeout(() => openSub(level, idx), 130);
      });
      row.addEventListener('click', (e) => { e.stopPropagation(); activate(level, idx); });
      pane.rows.push({ it: it, row: row });
      pane.el.append(row);
    });
    pane.el.addEventListener('contextmenu', (e) => e.preventDefault());
    pane.el.addEventListener('pointerleave', () => { if (panes[level] === pane && !(panes[level + 1])) setActive(level, -1); });
    return pane;
  }

  function onKey(e) {
    if (!root) return;
    const level = panes.length - 1, p = panes[level], n = p.rows.length, k = e.key;
    const move = (d) => {
      if (!n) return;
      let i = p.active;
      for (let t = 0; t < n; t++) { i = (i + d + n) % n; if (usable(p.rows[i])) break; }
      if (i < 0 || !usable(p.rows[i])) return;
      setActive(level, i);
    };
    if (k === 'Escape' || k === 'Tab') { if (level > 0 && k === 'Escape') { closeDeeper(level - 1); } else close(); }
    else if (k === 'ArrowDown') { if (p.active < 0) { setActive(level, p.rows.findIndex(usable)); } else move(1); }
    else if (k === 'ArrowUp') { if (p.active < 0) { let l = -1; p.rows.forEach((r, i) => { if (usable(r)) l = i; }); setActive(level, l); } else move(-1); }
    else if (k === 'Home') setActive(level, p.rows.findIndex(usable));
    else if (k === 'End') { let l = -1; p.rows.forEach((r, i) => { if (usable(r)) l = i; }); setActive(level, l); }
    else if (k === 'ArrowRight') { if (p.active >= 0 && p.rows[p.active].it.sub) activate(level, p.active); }
    else if (k === 'ArrowLeft') { if (level > 0) closeDeeper(level - 1); }
    else if (k === 'Enter' || k === ' ') { if (p.active >= 0) activate(level, p.active); }
    e.preventDefault(); e.stopImmediatePropagation();
  }

  /** Öffnet das Menü bei (x, y) in Fensterkoordinaten. opts.kbd = true wählt gleich den ersten Eintrag. */
  function open(items, x, y, opts) {
    close(true);
    prevFocus = document.activeElement;
    root = el('div', 'ctxm');
    const pane = makePane(items, 0);
    root.append(pane.el); panes = [pane];
    document.body.append(root);
    place(pane, x, y, null);
    window.addEventListener('keydown', onKey, true);
    window.addEventListener('pointerdown', onDown, true);
    window.addEventListener('blur', onAway);
    window.addEventListener('resize', onAway);
    window.addEventListener('wheel', onWheel, { capture: true, passive: true });
    if (opts && opts.kbd) setActive(0, pane.rows.findIndex(usable));
  }

  return { open: open, close: close, isOpen: isOpen };
})();
export default CtxMenu;
